import { Injectable } from '@angular/core';
import { SaleDocumentStatusesService } from '../../sale-documents/sale-document-statuses/sale-document-statuses.service';
import { SaleCreditNoteHeaderStatus } from './sale-credit-note-header-status.model';

@Injectable({
  providedIn: 'root'
})
export class SaleCreditNoteHeaderStatusesService extends SaleDocumentStatusesService<SaleCreditNoteHeaderStatus> {
  public override url: string = 'SaleCreditNoteHeaderStatus';
 
  constructor() {
    super();
  }
}
